import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
    const token = localStorage.getItem("token");
    return openSocket(getBackendUrl(), {
      // "polling" first so realtime updates keep working even when the
      // reverse proxy in front doesn't forward WebSocket upgrade headers
      // (socket.io still tries to upgrade to "websocket" opportunistically
      // once the polling connection is established).
      transports: ["polling", "websocket"],
      query: {
        token: JSON.parse(token),
      },
    });
}

export default connectToSocket;